module.exports = __webpack_public_path__ + "static/media/INTERMARCHE-Bold.4f133e00.otf";